// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__87eyf","documentsWrapper":"styles_documentsWrapper__1scd9","documentTitle":"styles_documentTitle___8zuM"};